import { BrowserCacheLocation, Configuration } from '@azure/msal-browser';

export const msalConfig : Configuration = {
	auth: {
		clientId: process.env.REACT_APP_SPA_CLIENT_ID,
		authority: process.env.REACT_APP_AUTHORITY || 'https://login.microsoftonline.com/common/',
		redirectUri: process.env.REACT_APP_REDIRECT_URI
	},
	cache: {
		cacheLocation: BrowserCacheLocation.LocalStorage, // This configures where your cache will be stored
	}
};

export const apiConfig = {
	resourceUri: process.env.REACT_APP_API_URL,
	resourceScopes: [`${process.env.REACT_APP_API_CLIENT_ID}/.default`]
};

// Default is 30 minutes
export const idleTimeoutMs = +process.env.REACT_APP_IDLE_TIMEOUT_MS || 30 * 60 * 1000;

/** 
 * Scopes you enter here will be consented once you authenticate. For a full list of available authentication parameters, 
 * visit https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const request = {
	scopes: ['openid', 'profile', 'offline_access', ...apiConfig.resourceScopes],
	prompt: 'select_account'
};
